import { useQuery, UseQueryOptions } from '@tanstack/react-query'

import { useReportingApi } from '../../../api'
import { fetchQueueCalls } from '../api/queueApi'
import type { QueueCallsResponse } from '../types'
import { queueDashboardPollingOptions } from './queueDashboardPolling'

export const queueCallsQueryKeys = {
  all: ['queueCalls'] as const,
  list: (pbxUuid: string, queueNumber: string | null) =>
    [...queueCallsQueryKeys.all, pbxUuid, queueNumber] as const,
}

export interface UseQueueCallsOptions {
  pbxUuid: string | null
  queueNumber: string | null
  refreshInterval: number
  enabled: boolean
  options?: Omit<
    UseQueryOptions<QueueCallsResponse, Error>,
    'queryKey' | 'queryFn' | 'refetchInterval' | 'staleTime' | 'enabled'
  >
}

export const useQueueCalls = ({
  pbxUuid,
  queueNumber,
  refreshInterval,
  enabled,
  options = {},
}: UseQueueCallsOptions) => {
  const api = useReportingApi()

  return useQuery<QueueCallsResponse, Error>({
    queryKey: queueCallsQueryKeys.list(pbxUuid ?? '', queueNumber),
    queryFn: async ({ signal }) =>
      fetchQueueCalls(api, pbxUuid!, queueNumber!, signal),
    enabled: !!pbxUuid && !!queueNumber && enabled,
    ...options,
    ...queueDashboardPollingOptions(enabled, refreshInterval),
  })
}

export default useQueueCalls
